/**
 * 电话图标
 */
const FillTelIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#E1E1E4" />
      <path
        d="M8.65636 5.32812L6 7.34335C8.6602 14.0012 10.6597 16.0398 16.6597 18.0031L18.6747 15.3464L16.6599 13.3317L15.328 13.3372L14.5405 14.2154C11.9961 13.46 10.2046 10.6331 9.63305 9.30789L10.6616 8.67081L10.6616 7.33342L8.65636 5.32812Z"
        fill="black"
      />
    </svg>
  )
}

export default FillTelIcon
